(function () {
  if (window.__cjQuickAdd) return;
  window.__cjQuickAdd = true;

  // Clarity: custom events zijn terug te vinden onder Filters > Custom events
  function clarityEvent(naam) {
    try { if (typeof window.clarity === 'function') window.clarity('event', naam); } catch (e) {}
  }

  // Zet elk knopje in de foto van zijn eigen kaart, zodat het in elke weergave
  // (normaal / 5 / 2 naast elkaar) netjes in de hoek van de foto staat.
  function plaats() {
    document.querySelectorAll('.product-grid > .grid__item > .cj-qa').forEach(function (qa) {
      var inner = qa.parentElement.querySelector('.card__inner');
      if (inner) inner.appendChild(qa);
    });
  }
  plaats();
  document.addEventListener('DOMContentLoaded', plaats);
  (function kijk() {
    var doel = document.getElementById('ProductGridContainer') || document.body;
    if (!doel) return;
    var bezig = false;
    new MutationObserver(function () {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(function () { bezig = false; plaats(); });
    }).observe(doel, { childList: true, subtree: true });
  })();

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var src = doc.querySelector('.shopify-section');
    if (src) target.innerHTML = src.innerHTML;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cj-qa__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    clarityEvent('snel_toevoegen_klik');

    if (btn.dataset.multi === 'true') {
      clarityEvent('snel_toevoegen_naar_product');
      window.location.href = btn.dataset.productUrl;
      return;
    }
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var cart = getCart();
    var variantId = Number(btn.dataset.variantId);
    var body = { id: variantId, quantity: 1 };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    } else {
      body.sections = ['cart-icon-bubble'];
    }

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, d: d }; });
      })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok || res.d.status) {
          window.location.href = btn.dataset.productUrl;
          return;
        }
        var d = res.d;
        clarityEvent('snel_toevoegen_gelukt');

        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList) cart.classList.remove('is-empty');
          try { cart.renderContents(d); } catch (err) { console.error(err); updateBubble(d.sections); }
        } else {
          updateBubble(d.sections);
        }

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cj-quick-add', productVariantId: variantId, cartData: d });
          }
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('cj:cart-added', { detail: d }));

        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function (err) {
        console.error(err);
        btn.classList.remove('is-loading');
        window.location.href = btn.dataset.productUrl;
      });
  });
})();
